export default "__VITE_ASSET__Dxq0TxMQ__"